import React, { useState } from "react";
import styled from "styled-components";

const About = () => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const handlePhoneChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleDeleteProfile = () => {
    // Your delete profile logic goes here
    console.log("Profile deleted!");
  };

  return (
    <Container>
      <Content>
        <TextSection>
          <Tagline>Pepchat</Tagline>
          <Title>
             <ColoredText>Delete your profile</ColoredText> 
          </Title>
       
          <InputSection>
            <PhoneNumberInput
              type="text"
              placeholder="Enter your phone number"
              value={phoneNumber}
              onChange={handlePhoneChange}
            />
          </InputSection>
          <DeleteProfileButton onClick={handleDeleteProfile}>
            Delete Profile
          </DeleteProfileButton>
         
        </TextSection>
      </Content>
    </Container>
  );
};

export default About;

const Container = styled.div`
  background-color: #000;
  color: #fff;
  min-height: 60vh;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const TextSection = styled.div`
  flex: 1;
`;

const Tagline = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 48px;
  }
`;

const InputSection = styled.div`
  margin: 20px 0;
`;

const PhoneNumberInput = styled.input`
  padding: 10px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  margin-top: 10px;
  background-color: #333;
  color: #fff;
  border: 1px solid #444;
  border-radius: 5px;
`;

const DeleteProfileButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  background-color: #ff5a5f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #d43f3f;
  }
`;

const ColoredText = styled.span`
  background: linear-gradient(90deg, #ff5a5f, #6e5bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
